<div class="field">
  <label for="CastCatSelectorDd" class="do-not-wrap-text">{{labelKey}}</label>
  <div class="p-inputgroup">
    <p-button icon="pi pi-pencil" styleClass="p-button-warning" (onClick)="onCategoryEditButton($event)" [disabled]="!isThereSelection"
            pTooltip="Редактировать название группы" tooltipPosition="top"></p-button>
    <p-dropdown id="CastCatSelectorDd"
                [options]="_castCatList"
                optionLabel="CASTCATNAME"
                [(ngModel)]="_selectedCategory"
                placeholder="Выбор группы"
                filterPlaceholder="Поиск..."
                [filter]="true"
                filterBy="CASTCATNAME"
                [showClear]="allowClear"
                [disabled]="_disabled"
                [virtualScroll]="true"
                [virtualScrollItemSize]="31"
                [autofocusFilter]="false" 
                (onClick)="onClickCS($event)"
                (onChange)="onChangeCS($event)"
                (onClear)="onClearCS($event)"
                (onFilter)="onFilterOptions($event)"
                class="col"></p-dropdown>
    <p-button icon="pi pi-plus" styleClass="p-button-warning" (onClick)="onCategoryAddButton($event)" [disabled]="cannotAddGroup"
            pTooltip="Добавить группу" tooltipPosition="top"></p-button>
  </div>
</div>
